export default __webpack_public_path__ + "static/media/CartBlack.14c899f5.svg";